import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <HelmetProvider>
        <Helmet>
            <title>Lien brisé - Société Mikalo</title>
        </Helmet>

        <div id="_404main">
          <div className='_404main-content'>
            <div className='_404main-logo'>
              <img src="/images/logo.png" alt="" />
            </div>
            <div className='text-center title'>
              <h1>Oops! 404 - Page introuvable</h1>
              <p>Cette page semble inexiste ou déjà supprimée.</p>
            </div>
            <div className='text-center'>
              <Link to="/" className='btn btn-primary'>Revenir sur la page d'accueil</Link>
            </div>
          </div>
        </div>
    </HelmetProvider>
  )
}
